import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

export const RoiTableStyles = {
  analyticsContainer: css`
    background-color: ${theme.colors.primary.contrastWhite};
    border-radius: 8px;
  `,
};
